// Money Format
theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();

//Custom-product-variants on Product page
document.addEventListener('DOMContentLoaded', ()=>{  
  const Main_Stand_Container = document.querySelectorAll('.stand-custom-product');
  const Main_Stand_Container_with_product = document.querySelector('.stand-custom-product.stand-product');
  if(Main_Stand_Container.length > 0){
    Main_Stand_Container.forEach(stand_variant=>{
      if(stand_variant){
        const stand_boxes = stand_variant.querySelectorAll('.custom-variant-box');
        if(stand_boxes.length > 0){
          stand_boxes.forEach(box=>{
            if(box){
              //console.log(box.querySelector('input').getAttribute('value'))              
              box.addEventListener('click',()=>{
                const innerInputValue = box.querySelector('input').getAttribute('value');                
                const innerInputVariantPrice = Number(box.querySelector('input').getAttribute('data-variant-price'));
                const MainVariantPrice = Number(document.querySelector('.main-product-price').getAttribute('value'));
                const FinalPrice = innerInputVariantPrice + MainVariantPrice;
                const FormatedFinalPrice = theme.Currency.formatMoney(FinalPrice, theme.settings.moneyFormat);
                //console.log(FormatedFinalPrice);
                stand_boxes.forEach(boxx=>{
                  boxx.classList.remove('active');
                })
                box.classList.add('active');
                const main_product_price = document.querySelector('[data-product-blocks] .product__price span');
                main_product_price.innerHTML = FormatedFinalPrice;               
                if(box.parentElement.classList.contains('stand-labels')){                  
                  if(innerInputValue == "Yes" || innerInputValue == "Ja"){
                    Main_Stand_Container_with_product.style.display = "block";
                    Main_Stand_Container_with_product.querySelector('.custom-variant-box.active').click();
                  }else{
                    Main_Stand_Container_with_product.style.display = "none";                    
                  }
                }
              })              
            }
          })
        }        
      }
    })
  }
  if(Main_Stand_Container_with_product && Main_Stand_Container_with_product.querySelector('.custom-variant-box.active')){    
    //Main_Stand_Container_with_product.querySelector('.custom-variant-box.active').click();
  }
});


// function to add tv stand metafield product
(function() {
    const submitBtn = document.querySelector("[data-section-type='product'] [data-add-to-cart][type='button']");
    if (!submitBtn) return;

    submitBtn.addEventListener("click", function(event) {
        event.preventDefault();

        const productWrapper = event.currentTarget.closest("[data-section-type='product']");
        const variantId = productWrapper.querySelector("[name='id']")?.value;
        const quantity = productWrapper.querySelector("[name='quantity']")?.value;
        if (!variantId || !quantity) return;

        const itemsArray = [{ id: variantId, quantity }];
        const isStandSelected = document.querySelector(".custom-variant-box.active input")?.value.toLowerCase();
        if (isStandSelected === "ja" || isStandSelected === "yes") {
            const metaStandVariantId = productWrapper.querySelector(".meta-tv-box input")?.getAttribute("data-variant-id");
            if (metaStandVariantId) {
                itemsArray.push({ id: metaStandVariantId, quantity });
            }
        }

        const formData = { items: itemsArray };
        console.log({ variantId, quantity, isStandSelected, itemsArray });

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(response => {
            if (response.items.length) {
                window.location.href = `${window.Shopify.routes.root}cart`;
            }
        })
        .catch(error => console.error('Error:', error));
    }, true);
})();
